import { useState, useEffect } from 'react';
import { Switch, Route, withRouter, useParams } from 'react-router-dom'
import { fetch, patch, create, remove } from '../api/methods'
import * as links from '../api/links'
import moment from 'moment'

const base64Data = "SGVsbG8sIFdvcmxkIQ=="; // Пример: Hello, World!

export default function Sign() {

  const {id} = useParams();
  const [data, setData] = useState(null);
  const [signature, setSignature] = useState('');
  const [loading, setLoading] = useState(false);
  const [certList, setCertList] = useState([]);
  const [selectedCert, setSelectedCert] = useState('');

  // Ожидание полной инициализации плагина
    useEffect(() => {
      const waitForCadesPlugin = () => {
        return new Promise((resolve, reject) => {
          const start = Date.now();
          const timeout = 20000;
  
          const check = () => {
            const plugin = window.cadesplugin;
            if (
              plugin &&
              typeof plugin.CreateObjectAsync === 'function' &&
              typeof plugin.CADESCOM_CADES_BES !== 'undefined'
            ) {
              return resolve(true);
            }
  
            if (Date.now() - start > timeout) {
              return reject(new Error('Плагин не загрузился за 20 секунд.'));
            }
  
            setTimeout(check, 100);
          };
  
          check();
        });
      };
  
      waitForCadesPlugin()
        .then(() => {
          console.log('✅ CryptoPro плагин готов');
        
        })
        .catch((err) => {
          console.error('❌ Плагин не готов:', err);
          alert('Ошибка инициализации плагина: ' + err.message);
        });
    }, []);

    useEffect(() => {
      if(id){
        setLoading(true)
        fetch(links.SIGN_ID, {id})
            .then((data)=>{
              setData(data)
              if (data?.sig) {
                setSignature(data?.sig)
              }
            })
            .catch(e => console.log(e))
            .finally(() => setLoading(false));
      }
    }, []);

  function run(sCertName) {
    const cadesplugin = window.cadesplugin;
    cadesplugin.async_spawn(function* (args) {
      
        // Ищем сертификат для подписи
        var oStore = yield cadesplugin.CreateObjectAsync("CAdESCOM.Store");
        yield oStore.Open(cadesplugin.CAPICOM_CURRENT_USER_STORE, cadesplugin.CAPICOM_MY_STORE,
            cadesplugin.CAPICOM_STORE_OPEN_MAXIMUM_ALLOWED);

        var oStoreCerts = yield oStore.Certificates;
        var oCertificates = yield oStoreCerts.Find(
            cadesplugin.CAPICOM_CERTIFICATE_FIND_SUBJECT_NAME, sCertName);
        var certsCount = yield oCertificates.Count;
        if (certsCount === 0) {
            alert("Certificate not found: " + sCertName);
            return;
        }
        var oCertificate = yield oCertificates.Item(1);
        yield oStore.Close();

        // Создаем объект CAdESCOM.CPSigner
        var oSigner = yield cadesplugin.CreateObjectAsync("CAdESCOM.CPSigner");
        yield oSigner.propset_Certificate(oCertificate);
        yield oSigner.propset_CheckCertificate(true);

        const signedData = yield cadesplugin.CreateObjectAsync("CAdESCOM.CadesSignedData");

        // Указываем тип кодировки: base64 → бинарные данные
        yield signedData.propset_ContentEncoding(cadesplugin.CADESCOM_BASE64_TO_BINARY);

        // Передаём Base64-данные (будут декодированы)
        // yield signedData.propset_Content(base64Data);
        yield signedData.propset_Content(data.base64);

       // Выполняем подпись (detached — откреплённая)
        const signature = yield signedData.SignCades(
          oSigner,
          cadesplugin.CADESCOM_CADES_BES,
          true
        );

        setSignature(signature)
        console.log("Detached подпись:", signature);

        setLoading(true)
        create(links.SIGN_ID, {
            params: {
                id
            },
            data: {sig: signature}
        })
        .catch(e => console.log(e))
        .finally(() => setLoading(false));

    });
  }

  const loadCertificates = async () => {
    try {

      const cadesplugin = window.cadesplugin;
      const store = await cadesplugin.CreateObjectAsync("CAdESCOM.Store");
      await store.Open(cadesplugin.CAPICOM_CURRENT_USER_STORE, cadesplugin.CAPICOM_MY_STORE,
      cadesplugin.CAPICOM_STORE_OPEN_MAXIMUM_ALLOWED);

      const certs = await store.Certificates;
      const count = await certs.Count;
      const list = [];

      for (let i = 1; i <= count; i++) {
        const cert = await certs.Item(i);
        const subject = await cert.SubjectName;
        list.push(subject);
      }

      setCertList(list);
      await store.Close();
    } catch (err) {
      console.error("Ошибка загрузки сертификатов:", err);
      alert("Не удалось загрузить сертификаты.");
    }
  };

  function extractCN(subjectName) {
    const match = subjectName.match(/CN=([^,]+)/);
    return match ? match[1] : subjectName;
  }

  async function verifySignature(base64, sig) {

  const plugin = window.cadesplugin

   return new Promise((resolve, reject) => {
    plugin.async_spawn(function* () {
      try {
        const signedData = yield plugin.CreateObjectAsync("CAdESCOM.CadesSignedData");

        yield signedData.propset_ContentEncoding(
          plugin.CADESCOM_BASE64_TO_BINARY
        );

        yield signedData.propset_Content(base64);

        yield signedData.VerifyCades(
          sig,
          plugin.CADESCOM_CADES_BES,
          true
        );

        console.log(1);
        

        resolve(true);
      } catch (e) {
        console.log(2);
        
        reject(e);
      }
    });
  });
}


  return (
      <div>
        <div className='info-box'>
          <h2 className='info-title'>Организация</h2>
          <p className='info'>{data?.data?.title}</p>
          <p className='info'>{data?.data?.inn}{data?.data?.kpp ? '/'+data?.data?.kpp : null}</p>
          <p className='info'>ОГРН: {data?.data?.ogrn}</p>
          <p className='info'>Подписант: {data?.data?.signer}</p>
        </div>
        <div className='info-box'>
          <h2 className='info-title'>ККТ</h2>
          <p className='info'>ОФД: {data?.data?.ofd_title}</p>
          <p className='info'>ИНН ОФД: {data?.data?.ofd_inn}</p>
          <p className='info'>Модель ККТ: {data?.data?.model_kkt}</p>
          <p className='info'>Заводской номер ККТ: {data?.data?.zn_kkt}</p>
          <p className='info'>Модель ФН: {data?.data?.model_fn}</p>
          <p className='info'>Заводской номер ФН: {data?.data?.zn_fn}</p>
          <p className='info'>Адрес установки ККТ: {data?.data?.adress_kkt}</p>
          <p className='info'>Место установки ККТ: {data?.data?.place_kkt}</p>
          <p className='info'>Номер автоматического устройства для расчетов: {data?.data?.number_automat}</p>
          <p className='info'>Адрес установки автоматического устройства для расчетов: {data?.data?.adress_automat}</p>
          <p className='info'>Место установки автоматического устройства для расчетов: {data?.data?.place_automat}</p>
        </div>
        <div className='info-box'>
          <h2 className='info-title'>Использование</h2>
          <p className='info'>Автоматический режим: {data?.data?.regime & (4) ? "ДА" : "НЕТ"}</p>
          <p className='info'>ККТ для услуг: {data?.data?.regime & (8) ? "ДА" : "НЕТ"}</p>
          <p className='info'>Признак БСО: {data?.data?.regime & (16) ? "ДА" : "НЕТ"}</p>
          <p className='info'>ТОЛЬКО для Интернет (ТОЛЬКО безнал): {data?.data?.regime & (32) ? "ДА" : "НЕТ"}</p>
          <p className='info'>Расширенные режимы работы ККТ: {data?.data?.extended_regime ? "ДА" : "НЕТ"}</p>
          <p className='info'>Продажа подакцизных товаров: {data?.data?.extended_regime & (1) ? "ДА" : "НЕТ"}</p>
          <p className='info'>Проведение азартных игр: {data?.data?.extended_regime & (2) ? "ДА" : "НЕТ"}</p>
          <p className='info'>Проведение лотерей: {data?.data?.extended_regime & (4) ? "ДА" : "НЕТ"}</p>
          <p className='info'>Продажа маркированных товаров: {data?.data?.extended_regime & (16) ? "ДА" : "НЕТ"}</p>
          <p className='info'>Ломбардная деятельность: {data?.data?.extended_regime & (32) ? "ДА" : "НЕТ"}</p>
          <p className='info'>Страховая деятельность: {data?.data?.extended_regime & (64) ? "ДА" : "НЕТ"}</p>
        </div>

        <div style={{ padding: '20px', fontFamily: 'sans-serif' }}>
          <h2>Подпись XML-файла через КриптоПро</h2>

          {certList.length > 0 
            ? (
                <>
                  <label htmlFor="certSelect">Выберите сертификат:</label>
                  <select
                    id="certSelect"
                    onChange={(e) => setSelectedCert(e.target.value)}
                    value={selectedCert}
                  >
                    <option value="">-- выберите --</option>
                    {certList.map((name, idx) => (
                      <option key={idx} value={name}>{name}</option>
                    ))}
                  </select>
                  <br /><br />
                </>
              ) 
            : <button onClick={async()=>{await loadCertificates()}}>Выбрать сертификат</button>
          }

       
          <button onClick={()=>{run(extractCN(selectedCert))}} disabled={loading}>
            {loading ? 'Подписание...' : 'Подписать'}
          </button>
           

          {signature && (
            <>
              <h4>Откреплённая подпись (Base64):</h4>
              <button onClick={async()=>{ console.log(await verifySignature(data.base64, signature))}}>Проверить</button>
              <textarea value={signature} readOnly rows={10} style={{ width: '100%' }} />
            </>
          )}
        </div>
      
      </div>
  );
}
